import React, { useEffect, useState } from "react";
import api from '../../services/api';
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import { DynamicTextareaOnChange } from "../../components/DynamicTextarea";
import { StyledForm } from "../../styled-components/StyledForm.style";

export const ModalVisibilidadeIniciar = ({
    processo,
    laudo,
    isOpen,
    setIsOpen,
    aoSalvar
}) => {
    const [isLoading, setisLoading] = useState(false);
    const [loadAcao, setLoadAcao] = useState(null);
    const [observacao, setObservacao] = useState("");

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    }

    const onAfterOpen = () => { };
    const closeModal = () => { 
        setObservacao("");
        setisLoading(false);
        setIsOpen(false); 
    }

    const getLoadAcao = async (idTarefa) => {
        setisLoading(true);
        let list = null;
        try {
            const response = await api.get(`Visibilidade/tarefa/load/acao/${idTarefa}`);
            list = response.data.data;
            setLoadAcao(list);
        } catch (err) {
            console.error(err);
        } finally {
            setisLoading(false);
            return list;
        }
    }

    const onClickAction = (idTarefa, tipoAcao) => {
        Swal.fire({
            html: `Deseja Realizar essa Ação?`,
            icon: "info",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            setisLoading(true);
            if (result.isConfirmed) {
                Swal.showLoading();
                try {
                    const headers = {
                        'Content-Type': 'application/json'
                    };

                    const dados = {
                        idTipoAcao: tipoAcao,
                        observacao: observacao,
                    };
                    await api.post(`Visibilidade/tarefa/executa/iniciar/${idTarefa}`, dados, { headers });
                    setisLoading(false);

                    Swal.fire({
                        title: "Sucesso",
                        text: "Tarefa Executada com Sucesso!",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    }).then(async (result) => {;
                        setObservacao("");

                        setisLoading(false);
                        setIsOpen(false);
                        closeModal();

                        if (aoSalvar) {
                            aoSalvar(laudo.idProcesso, laudo.idTipoServico);
                        }
                    })

                } catch (err) {setisLoading(false);}
            } else {
                setisLoading(false);
            }
            
        });
    };

    useEffect(() => {
        if(isOpen) {
            getLoadAcao(processo.idTarefa);
        }
    }, [isOpen])

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Iniciar"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="28" height="28" className="me-2">
                                        <path fill={'#999'} path d="M91.2 36.9c-12.4-6.8-27.4-6.5-39.6 .7S32 57.9 32 72l0 368c0 14.1 7.5 27.2 19.6 34.4s27.2 7.5 39.6 .7l336-184c12.8-7 20.8-20.5 20.8-35.1s-8-28.1-20.8-35.1l-336-184z"/></svg>
                                    Iniciar - { loadAcao?.nomeEtapa } </p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}><button className="default-button-red-small px-2">X</button></p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                { isLoading ? 
                (
                <div className="text-center">
                    <div className="text-items-center">
                        <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                        <div className="mt-2">
                            <strong style={{ color: "#EE4B21" }}>Aguarde enquanto validamos as informações</strong>
                        </div>
                    </div>
                </div>
                ) : (
                    <>
                    <div className="row mb-2" style={{ fontSize: "14px" }}>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Processo</span><br/>{ loadAcao?.processo?.processoSigla || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Líder</span><br/>{ loadAcao?.processo?.liderProcesso || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Cliente</span><br/>{ loadAcao?.processo?.cliente || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Segurado</span><br/>{ loadAcao?.processo?.segurado || "-" }</div>
                    </div>
                    <div className="row" style={{ fontSize: "14px" }}>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Disciplina</span><br/>{ laudo.disciplina }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Responsável</span><br/>{ loadAcao?.nomeUsuarioResponsavel || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Data Criação</span><br/>{ new Date(loadAcao?.dataCriacao).toLocaleDateString('pt-BR') }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Data Prazo</span><br/>{ new Date(loadAcao?.dataPrazo).toLocaleDateString('pt-BR') }</div>

                    </div>
                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                    <div className="row align-items-center justify-content-center w-100">
                        <div className="col text-center">
                            <DynamicTextareaOnChange 
                                placeholder={"Observações"} 
                                label={"Observações"} 
                                name={"observacao"}
                                valuetext={observacao}
                                onChange={(e) => setObservacao(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                    <Flex>
                        <Flex.Item>
                            <div className="row align-items-center justify-content-center">
                                <div className="col text-center">
                                    <input 
                                        className='default-button-red' 
                                        value={'Iniciar'} 
                                        type="button" 
                                        onClick={onClickAction.bind(this, loadAcao?.idTarefa, 2)}/>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    </>
                )}
            </StyledForm>
        </Modal>
    );
};